import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import './SideMenu.css';
import { connect } from 'react-redux'
import {logout} from '../../../../Actions/authAction'
import {hideSideMenu} from '../../../../Actions/MyHavenSideMenuAction'
import * as firebase from 'firebase';

class SideMenu extends Component {
    state = {
        displayPasswordUpdate: "none",
        oldPassword: '',
        newPassword: '',
        mainLabel: 'Update Password'
    }


    updatePassword = (event) => {
        event.preventDefault();
        var newPassword = this.state.newPassword;
        var oldPassword = this.state.oldPassword;
        var user = firebase.auth().currentUser;
        var credential = firebase.auth.EmailAuthProvider.credential(user.email,oldPassword);
        user.reauthenticateWithCredential(credential).then(() => {
           user.updatePassword(newPassword).then(() =>{
                // Update successful.
                this.setState({
                mainLabel: "Password Updated!",
                    
                })
              }).catch((error) =>{
                // An error happened.
                console.log(error.code, error.message);
                this.setState({
                    mainLabel: "New password must be 6 characters.",
                    
                })
              });
        }).catch((error)=>{
            console.log(error.code)
            if(error.code === "auth/wrong-password"){
                this.setState({
                    mainLabel: "Your old password was incorrect."
                })
            }
        });
       
       
    }



    render() { 
        return ( 
            
    
            <div>
                
                    <form id="updatePasswordForm" >
                        <ul >
                        <li>{this.state.mainLabel}</li>
                        <li><input placeholder="Enter OLD Password"  type="password" onChange={(event) => this.setState({ oldPassword: event.target.value})}/></li>
                        <li><input placeholder="Enter New Password"  type="password" onChange={(event) => this.setState({ newPassword: event.target.value})}/></li>
                        <li><button className="btn btn-primary"  onClick={this.updatePassword}>Update Password</button></li>
                        <li>  <a className="dropdown-item"><i className="fas fa-sign-out-alt"></i><span className="logout-link" onClick={this.props.logout}> Logout</span></a></li>
                        </ul>
                    </form>
             </div>
    
         )
    }
}
 
const mapStateToProps = state => ({

})

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => dispatch(logout()),
        
  }
}
export default connect(mapStateToProps, mapDispatchToProps) (SideMenu);


// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/SideMenu/SideMenu.jsx